import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";

export function AirportPickupFeeInfoStep({setStep, closeModal, previousStep}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} cancelButtonType="icon" backStep={previousStep || 'pricingBreakdown'} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <div className="hopn-airport-pickup-fee-info modalPages-spacing pb-8">
                <p>Coming soon</p>
            </div>
        </>
    );
}
export default AirportPickupFeeInfoStep;
